import * as types from '../mutation_types';

export default {
  [types.SET_ROOMS](state, value) {
    state.rooms = value;
  }
}
